/* eslint-disable */
import { Middleware, MiddlewareSync } from "@sa/rep-common";
import { DataFlowProcessingState, ComponentContextProcessingState } from "@sa/rep-core";
import { ContextExample } from "../ContextExample";

export const exampleContextsMiddleware: MiddlewareSync<ComponentContextProcessingState> = (input, next) => {
  if (input.identification.componentId === "EXMPL" && input.identification.reportId === "example") {
    input.componentContext = new ContextExample(input.identification.componentId, input.createOptions);
    return input;
  } else {
    return next(input);
  }
};
